import {td_action} from "../../api/td_action.api"

const state = {
    td_action: [],
}

const mutations = {
    set_td_action(state, td_action) {
        state.td_action = td_action
    },
}

const actions = {
    get_td_action(context) {
        return new Promise((resolve, reject) =>
            td_action()
                .then((response) => {
                    if (response.status == '200') {
                        let td_action = response.data;
                        context.commit('set_td_action', td_action)

                        resolve(response)
                    }
                })
                .catch(error => {
                    reject(error)
                })
        )
    }
}

const getters = {
    get_td_action_tree: state =>
    {
        let hashTable = Object.create(null)
        let dataset = state.td_action
        dataset.forEach( aData => hashTable[aData.id] = { ...aData, children : [] } )
        let dataTree = []
        dataset.forEach( aData => {
            if( aData.id_parent )
                hashTable[aData.id_parent].children.push(hashTable[aData.id])
            else
                dataTree.push(hashTable[aData.id])
        } )

        return removeEmpty(dataTree)
    },

    get_td_action_txt: state => (id, path) => {

        return buildActionTxt(state, id, path)

    },

    get_td_action_parent: state =>
    {
        let result = []
        state.td_action.forEach(
            aData => {
            if( aData.id_parent == 0)
                result.push(aData)
        } )

        return result
    }
}

const buildActionTxt = (state, id, path) => {

    let action = state.td_action.filter(function(td_action) {
        return td_action.id == id
    })[0];

    path =  action.name + ' ' + path

    if( action.id_parent ) {
        return buildActionTxt(state,action.id_parent, path)
    }
    else
        return path
}

const removeEmpty = (obj) => {
    Object.keys(obj).forEach(key =>
        (key === 'children' && obj[key].length === 0) && delete obj[key] ||
        (obj[key] && typeof obj[key] === 'object') && removeEmpty(obj[key])
    );
    return obj;
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}